<main [class]="shellClass">
  @if (loading()) {
    <div class="loading-overlay" aria-label="Loading Acorn Guild" role="status">
      <div class="loading-inner">
        <div class="loading-spinner"></div>
        <p class="loading-title">Acorn Guild</p>
      </div>
    </div>
  }

  <section class="frame-wrap">
    @if (!secureRedirectUrl) {
      <iframe
        title="Acorn Guild Godot"
        [src]="godotSrc"
        allow="fullscreen; gamepad; virtual-keyboard"
        referrerpolicy="same-origin"
        (load)="onIframeLoad()">
      </iframe>
    }
  </section>
</main>
